import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useUser } from '../../../store/reducers/user';
import {
    clearUnauthorizedForm,
    loadLocalQuestionsFields,
    loadUnauthorizedForm,
    saveLocalQuestionsFields,
    saveUnauthorizedForm,
} from '../../../helpers/form.new';
import { extendFormData } from '../../../store/reducers/formStore';
import { useFormData } from '../../../store/selectors/formStore';
import { removeUndefined } from '../../../helpers';
import { useAbAdditionalQuestions } from '../../../helpers/experiments/additional.questions';

/**
 * Сохраняет данные первого шага анкеты в sessionStorage, пока пользователь не авторизован.
 * Подгружает данные сразу после авторизации.
 * */
export const useLocal = (enabled = false) => {
    const user = useUser();
    const dispatch = useDispatch();
    const formData = useFormData();

    const additionalQuestionsVariant = useAbAdditionalQuestions();
    const isShowAdditionalQuestions = additionalQuestionsVariant === '1';

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const dataParsed = Object.assign(
            {},
            loadUnauthorizedForm(),
            isShowAdditionalQuestions ? loadLocalQuestionsFields() : {},
        );

        if (Object.keys(dataParsed).length) {
            dispatch(extendFormData(removeUndefined(dataParsed, [''])));
        } else {
            clearUnauthorizedForm();
        }
    }, [user, enabled, dispatch, isShowAdditionalQuestions]);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        saveLocalQuestionsFields(formData);

        if (!formData.sn) {
            saveUnauthorizedForm(formData);
        }
    }, [formData, user, enabled, dispatch]);
};
